<template>
  <div class="wireInquireResult container">
    <div class="px-0">
      <b-col cols="12" class="px-0">
        <div>
          <table class="my-3">
            <tr>
              <td class="work-code-text">工單編號</td>
              <td class="work-code-val">{{ wireInquireWorkCode }}</td>
            </tr>
          </table>
          <div class="text-left my-3">線材使用紀錄(點擊線材查看詳細資料)</div>
          <b-table
            :items="wireInquireResultItemView"
            :fields="wireInquireResultFields"
            :no-border-collapse="noCollapse"
            @row-clicked="onRowClicked"
            fixed
            class="wire-inquery-result-table-detail"
            :tbody-tr-class="rowClass"
          >
            <template #thead-top="">
              <b-tr>
                <b-th
                  colspan="7"
                  style="
                    background-color: #4b8c80;
                    color: #ffffff;
                    border-color: #4b8c80;
                    font-family: 'dfyuanstd-w7';
                    font-size: 1.125rem;
                  "
                >
                  <span>查詢結果</span>
                </b-th>
              </b-tr>
            </template>
            <template #cell(item_index)="data">
              {{ data.item.isDetail ? "" : data.value }}
            </template>
            <template #cell(scales_data)="data">
              <span
                :style="{ color: data.value == '正常' ? '#000000' : '#c10000' }"
                >{{ data.value }}</span
              >
            </template>
          </b-table>
          <li class="text-left my-3">若秤架資料顯示異常,請於群組聯繫客服</li>
          <li class="text-left my-3">
            若秤架資料顯示正常,但線材重量和產出不符,可能與打頭人員操作APP時間點有關
          </li>
        </div>
      </b-col>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "wireInquireResult",
  data() {
    return {
      wireInquireResultItemView: [],
      noCollapse: false,
    };
  },
  watch: {
    wireInquireResultItem: {
      handler() {
        let vm = this;
        vm.wireInquireResultItemView = vm.wireInquireResultItem;
      },
    },
  },
  computed: {
    ...mapGetters({
      wireInquireResultFields: "wireInquireResult/get_wireInquireResultFields",
      wireInquireResultItem: "wireInquireResult/get_wireInquireResultItem",
      wireInquireWorkCode: "wireInquireResult/get_wireInquireWorkCode",
    }),
  },
  methods: {
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.isDetail && item.item_index % 2 != 0) {
        return "is-detail-odd";
      } else if (item.isDetail && item.item_index % 2 == 0) {
        return "is-detail-even";
      }
      if (!item.isDetail && item.item_index % 2 == 0) {
        return "even-item";
      } else if (!item.isDetail && item.item_index % 2 != 0) {
        return "odd-item";
      }
    },
    onRowClicked(items, index, event) {
      let vm = this;
      let obj = {
        items: items,
        index: index,
        event: event,
      };
      if (!items.isDetail && !items.isDetailShow) {
        vm.wireInquireResultItemView.splice(index + 1, 0, {
          scroll_no: "",
          start_weight:
            items.start_create.time + " (" + items.start_create.creator + ")",
          start_create: {
            time: items.start_create.time,
            creator: items.start_create.creator,
          },
          end_weight:
            items.end_create.time + " (" + items.end_create.creator + ")",
          usage: "",
          end_create: {
            time: items.end_create.time,
            creator: items.end_create.creator,
          },
          item_index: items.item_index,
          scales_data: "",
          furnace_code: "",
          code: "",
          isDetail: true,
        });
        vm.wireInquireResultItemView[index].isDetailShow = true;
      } else if (!items.isDetail && items.isDetailShow) {
        vm.wireInquireResultItemView.splice(index + 1, 1);
        vm.wireInquireResultItemView[index].isDetailShow = false;
      }
    },
  },
};
</script>

<style lang="scss">
.work-code-text {
  width: 128px;
  border: #999999 1px solid;
  padding: 6px 12px 6px 12px;
  text-align: center;
  font-size: 1rem;
  background-color: #4b8c80;
  color: #ffffff;
}
.work-code-val {
  width: 128px;
  border: #999999 1px solid;
  padding: 6px 12px 6px 12px;
  text-align: center;
  font-size: 1rem;
  background-color: #ffffff;
  color: #000000;
}
.wire-inquery-result-table-detail {
  min-width: 770px;
}
.wire-inquery-result-table-detail th,
.wire-inquery-result-table-detail td {
  height: 2.5rem;
  padding: 0.45rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  font-size: 1rem;
  font-family: "dfyuanstd-w5";
  vertical-align: middle !important;
}
.wire-inquery-result-table-detail th:first-child,
.wire-inquery-result-table-detail td:first-child {
  border-left: 1px solid;
}
.wire-inquery-result-table-detail th:last-child,
.wire-inquery-result-table-detail td:last-child {
  border-right: 1px solid;
}
.no-border-right {
  border-right: none !important;
}
.wire-inquery-result-table-detail {
  margin-bottom: 0px;
}
.wire-inquery-result-table-detail thead th {
  font-size: 1rem;
  color: #000000;
  background-color: #cccccc;
}

.odd-item {
  background-color: #ffffff;
}

.even-item {
  background-color: rgba(75, 140, 128, 0.2);
}

.is-detail-odd td:nth-child(1),
.is-detail-odd td:nth-child(2),
.is-detail-odd td:nth-child(6),
.is-detail-odd td:nth-child(7) {
  border-right: none !important;
  border-bottom: none !important;
  background-color: #ffffff;
}
.is-detail-odd td:nth-child(3) {
  border-bottom: none !important;
  background-color: #ffffff;
}

.is-detail-odd td:nth-child(1) {
  border-left: none !important;
}

.is-detail-even td:nth-child(1),
.is-detail-even td:nth-child(2),
.is-detail-even td:nth-child(6),
.is-detail-even td:nth-child(7) {
  border-right: none !important;
  border-bottom: none !important;
  background-color: #ffffff;
}
.is-detail-even td:nth-child(3) {
  border-bottom: none !important;
  background-color: #ffffff;
}
.is-detail-even td:nth-child(4),
.is-detail-even td:nth-child(5) {
  background-color: rgba(75, 140, 128, 0.2);
}
.is-detail-even td:nth-child(1) {
  border-left: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/wireInquireResult.vue